//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../Mechatronics/Mechatronics.GanttOperationConditionBuilderList.js";
import "../no/Expression.js";
import "../Mechatronics/Mechatronics.GanttOperationParameterBuilderList.js";
import "../no/Expression.js";
import "../no/ObjectList.js";
let d=[[[0,"ActiveStatus",1,0],[1,"ConditionList",0,"Mechatronics.GanttOperationConditionBuilderList",0],[0,"Context",1,"BasePart",0],[0,"Duration",1,0],[1,"ExpressionDuration",0,"Expression",0],[0,"OperationID",1,0],[0,"OperationName",1,0],[0,"OperationTypes",1,0],[1,"ParameterList",0,"Mechatronics.GanttOperationParameterBuilderList",0],[0,"ParentID",1,0],[0,"Physics",1,"NXObject",0],[0,"StartTime",1,0],[0,"Type",1,0]],[[["parameters"],"AddParameterList",{},1,0],[["conditions"],"AddConditionList",{},1,0],[["group","objects"],"SetOperationsGroup",{},2,0],[["index"],"SetSequenceNumber",{},1,0]],[]];
SPLM.Mechatronics.GanttOperationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.GanttOperationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.GanttOperationBuilder.SimpleOperationType = Object.freeze({
    "Simple" : "Simple", "Pause" : "Pause"});

SPLM.Mechatronics.GanttOperationBuilder.OperationType = Object.freeze({
    "Simple" : "Simple", "Commpound" : "Commpound", "Trigger" : "Trigger", "Pause" : "Pause"});

export default SPLM;